import { IncentiveAward } from '@varo/graphql-schema-types';
import { compareDesc, parseISO } from 'date-fns';
import { formatPrizeDate } from 'features/incentive/helpers/formatPrizeDate';
import { formatCurrency } from 'shared/utils/string/currency';

export interface WinnerAwardDisplay {
  amount: string;
  drawingDate: string;
}

export const getWinnerAwardDisplay = (
  awards: IncentiveAward[],
): WinnerAwardDisplay | undefined => {
  const latestAward = [...awards]
    .sort((first, second) =>
      compareDesc(parseISO(first.determinedAt), parseISO(second.determinedAt)),
    )
    .at(0);

  if (!latestAward) {
    return undefined;
  }

  const amount = Number(latestAward.amount.amount);

  if (!Number.isFinite(amount)) {
    return undefined;
  }

  return {
    amount: formatCurrency(amount, !Number.isInteger(amount)),
    drawingDate: formatPrizeDate(latestAward.determinedAt),
  };
};
